import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicFormationPDE = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="FORMATION OF PDE"
      videos={[
        "https://www.youtube.com/embed/Tr9dz-XnTWY",
        "https://www.youtube.com/embed/ED1ypNxZAy8",
        "https://www.youtube.com/embed/K5kVcOo42CI",
      ]}
      takeaways={[
        { text: "Practice as many problems as you can" },
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicFormationPDE;